<template>
  <div class="main-content-rows" v-loading="loading">
    <search
      :filted="filted"
      @date-change="dateChange"
      @type-change="typeChange"
      @filted-change="filtedChange"
      @export="exportExcel"
    ></search>

    <div class="main-content-cols">
      <side-menu
        v-if="false"
        :menus="menus"
        :actived="actived"
        @change="deviceChange"
      ></side-menu>

      <div class="main-content-cols__body">
        <el-row type="flex" style="flex: 1;margin-bottom: 0;">
          <el-col :span="8">
            <vmap ref="" :devs="devs"></vmap>
          </el-col>

          <el-col :span="16">
            <tdata
              ref="table"
              :loading="loadingData"
              :data="tableData"
              @play="goPlay"
            ></tdata>
          </el-col>
        </el-row>

        <el-row type="flex" style="flex: 1">
          <el-col :span="24">
            <schart :devs="devs" :data="tableData"></schart>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import sleep from '@/utlis/sleep'
import SideMenu from '@/components/MainSideMenu'
import FlvPlayer from '@/components/FlvPlayer'
import Search from './components/search'
import Vmap from './components/map'
import Tdata from './components/tdata'
import Schart from './components/chart'

import { getSdata } from '@/service/ykm'

export default {
  props: { _devs: Array },
  components: { SideMenu, Search, Vmap, Tdata, Schart },
  data() {
    return {
      loading: true,
      loadingData: true,
      filted: true,
      menus: [{ title: '总览', key: 'total' }],
      sdata: [],
      videos: [],
      actived: 0,
      query: {
        startTime: moment()
          .startOf('month')
          .format('YYYY-MM-DD+HH:mm:ss'),
        endTime: moment()
          .endOf('month')
          .format('YYYY-MM-DD+HH:mm:ss'),
        deviceId: ''
      }
    }
  },
  computed: {
    tableData() {
      return this.filted
        ? this.sdata.filter(s => Boolean(s.weight))
        : this.sdata
    },
    devs() {
      return this._devs.map((r, idx) => ({
        title: `${r.installAddress.slice(
          r.id.length * 2 - 6,
          r.id.length * 2
        )}-${idx + 1}`,
        ...r
      }))
    }
  },
  mounted() {
    const { startTime, endTime, deviceId } = this.query
    this.getData(startTime, endTime, deviceId)
  },
  methods: {
    async getData(startTime, endTime, deviceId) {
      this.loading = true
      const [{ data }] = await Promise.all([
        getSdata({
          companyId: this.companyId,
          startTime,
          endTime,
          deviceId
        }),
        // getVideo({
        //   companyId: this.companyId,
        //   startTime,
        //   endTime,
        //   deviceId
        // }),
        sleep(1)
      ])

      this.sdata = data
        .map(d => ({ ...d, namech: d.namech.replace('"', '') }))
        .sort((a, b) => {
          return moment(a.collectTime).isAfter(moment(b.collectTime)) ? -1 : 1
        })
      // this.videos = video
      this.loading = false
    },
    deviceChange(dev) {
      console.log(dev)
    },
    dateChange(s, e) {
      this.query.startTime = s
      this.query.endTime = e
      const { startTime, endTime, deviceId } = this.query
      this.getData(startTime, endTime, deviceId)
    },
    typeChange(type) {
      console.log(type)
    },
    filtedChange() {
      this.filted = !this.filted
    },
    exportExcel() {
      const b = moment(this.query.startTime).format('YYYYMMDD')
      const e = moment(this.query.endTime).format('YYYYMMDD')
      this.$refs.table.exportExcel(`鼠害-[${b}-${e}]`)
    },
    goPlay(row) {
      FlvPlayer({
        comId: this.companyId,
        yunId: row.yunId,
        title: row.deviceName,
        subtitle: `${moment(row.collectTime).format('YYYY-MM-DD HH:mm:ss')} | ${
          row.namech
        }`
      })
    }
  },
  watch: {
    devs(devs) {
      let menus = []
      if (!devs[0] || devs.length > 1) {
        menus.push({ title: '总览', key: 'total' })
      }
      this.menus = menus.concat(this.devs)
    }
  }
}
</script>

<style lang="css">
.page-rodent .main-content-cols,
.page-rodent .main-content-rows {
  height: 100%;
}
.page-rodent .main-content-sidebar {
  background-color: #fff;
}
</style>
